// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.transition-parent {
  position: relative; /*Necessary to hide overflowing children*/
  height: 100%;
  overflow: hidden;
}

.transition-view {
  position: absolute;
  width: 100%;
  height: 100%;

  top: 0;
  transition: top 500ms ease;
}

.transition-above {top: -100vh;}
/* .transition-visible {top: 0vh;} */
.transition-below {top: 100vh;}
`, "",{"version":3,"sources":["webpack://./src/style/transition.css"],"names":[],"mappings":";AACA;EACE,kBAAkB,EAAE,yCAAyC;EAC7D,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;;EAEZ,MAAM;EACN,0BAA0B;AAC5B;;AAEA,mBAAmB,WAAW,CAAC;AAC/B,oCAAoC;AACpC,mBAAmB,UAAU,CAAC","sourcesContent":["\n.transition-parent {\n  position: relative; /*Necessary to hide overflowing children*/\n  height: 100%;\n  overflow: hidden;\n}\n\n.transition-view {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n\n  top: 0;\n  transition: top 500ms ease;\n}\n\n.transition-above {top: -100vh;}\n/* .transition-visible {top: 0vh;} */\n.transition-below {top: 100vh;}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
